"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NavigationStepLabels;
(function (NavigationStepLabels) {
    NavigationStepLabels["EXTRAS"] = "extras";
    NavigationStepLabels["DEALER"] = "dealer";
    NavigationStepLabels["DETAILS"] = "details";
    NavigationStepLabels["CONFIRMATION"] = "confirmation";
    NavigationStepLabels["PAYMENT"] = "payment";
})(NavigationStepLabels = exports.NavigationStepLabels || (exports.NavigationStepLabels = {}));
